(function() {
    'use strict';
    angular.module('app')
        .controller('ResellerNetworkCarrierProfilesController', ResellerNetworkCarrierProfilesController);
    ResellerNetworkCarrierProfilesController.$inject = ['ClientService', '$routeParams','Carrier', 'toastr', 'SharedCarrierProfilesTableService', '$q'];
    function ResellerNetworkCarrierProfilesController(ClientService, $routeParams, Carrier, toastr, SharedCarrierProfilesTableService, $q){
        let vm = this;
        vm.id = $routeParams.id;

        (()=>{
            vm.isFetching = true;
            const initCalls = {
                reseller: getClientDetails(),
                carriers: getCarriers()
            };
            $q.all(initCalls).then(function (data) {
                vm.details = data.reseller;
                vm.sharedCarrierProfilesTable = new SharedCarrierProfilesTableService(data.carriers, vm.id).tableData;
                vm.isFetching = false;
            }).catch(error=>{
                vm.isFetching = false;
                vm.fetchError = true;
                toastr.error(error.message);
            });
        })();
        function getClientDetails() {
            const defer = $q.defer();
            ClientService.Company.get(vm.id, data=>{
                defer.resolve(data);
            }, error=>{
                defer.reject(error);
            });
            return defer.promise;
        }

        function getCarriers() {
            const defer = $q.defer();
            Carrier.getCarriers(function(data) {
                defer.resolve(data);
            }, function(err) {
                defer.reject(err);
            });
            return defer.promise;
        }
    }
})();


// WEBPACK FOOTER //
// ./js/controllers/networking/ResellerNetworkCarrierProfilesController.js